import { CheckoutTreeOverviewSchema } from "@redotech/redo-conversion-core-common/checkouts/checkout-tree";
import {
  ValidateCheckoutTreeTransformationError,
  ValidateCheckoutTreeTransformationWarning,
} from "@redotech/redo-conversion-core-common/checkouts/checkout-tree-transformation";
import { checkoutOptimizationStepArraySchema } from "@redotech/redo-model/advanced-flow/advanced-flow-db-parser";
import * as z from "zod";

export const validateCheckoutTreeTransformationForNewSplit = {
  name: "validateCheckoutTreeTransformationForNewSplit" as const,
  input: z.object({ flowSteps: checkoutOptimizationStepArraySchema }),
  output: z.object({
    warnings: z.array(ValidateCheckoutTreeTransformationWarning),
    errors: z.array(ValidateCheckoutTreeTransformationError),
    currentCheckoutTreeOverview: CheckoutTreeOverviewSchema.optional(),
    proposedCheckoutTreeOverview: CheckoutTreeOverviewSchema.optional(),
  }),
};
export type ValidateCheckoutTreeTransformationForNewSplitOutput = z.infer<
  typeof validateCheckoutTreeTransformationForNewSplit.output
>;
